import React from 'react';
import  {useState, useEffect,useRef,Suspense, lazy } from 'react'
import { ChallengeTypeContainer, CommonRightCard, CompletePointCardNew, ProfileContainer, ProgressBar, ProgressCircleWrapper, ProgressText, HoverIconWrapper } from './styles'
import { CalendarChallengeIcon, LocationChallengeIcon, RewardsChallengeIcon, PeopleChallengeIcon, InviteChallengeIcon, StepsIcon, CaloriesIcon, DisatanceIcon, ShowMoreArrow, ProgressTickIcon } from '../../utils/icons'
import { Divider, ManagerIconContainer, NameInitials } from '../Manager/styles'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux';
import { commaSeperator, convertDateInTimezone, convertMilesToKm, convertMonthFromDate, fetchApi, getInitials, getTimeToShow, rankingDashboard } from '../../utils/methods'
import moment from 'moment'
import Waiting from '../Waiting'
import { isEmpty, isNull } from 'lodash'
import LazyImage from '../common/LazyImage/LazyImage'
import { ImageUrl } from '../../utils/constants'
import { joinOrLeaveChallenge, getInviteAmigosList } from '../../redux/actions'
import { useDispatch } from 'react-redux';
const InviteAmigoPopUp = lazy(() => import('./InviteAmigoPopUp/inviteChallengePopup'))
import { useTranslation } from 'react-i18next';
import {CommonButtonBorder} from '../common/commonStyles'
import {AddUserIcon, RemoveUserIcon} from '../../utils/icons'
import { GetDailyGoalBreakdown } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import Timer from '../EventDetails/timer';
import dayjs from 'dayjs';

function ClassicRightScreen({ tabValue,challenge,userId, history, onAddUserPopup, getUserOverviewDetails, role, hasCompanyInRoute, companyId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const challengeAttendees = useSelector((state) => state.challenges.challengeAttendees);
  const userChallengeDetails = useSelector((state) => state.challenges.userChallengeDetails);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [showInviteAmigoPopup, setShowInviteAmigoPopup] = useState(false)
  const [showMore, setShowMore] = React.useState(false);
  const[dailyGoalData, setdailyGoalData] = useState([]);
  let lang = localStorage.getItem("lang");

  const [time, setTime] = useState(getTimeToShow(challenge, 'challenge'));
  const intervalRef = useRef(null);


  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setTime(getTimeToShow(challenge, 'challenge'));
    }, 1000);

    return () => {
      window.clearInterval(intervalRef.current);
    };
  }, [challenge]);


  useEffect(() => {
    if (challenge?.id && challenge?.event_type && userId) {
      getUserOverviewDetails(challenge.id, challenge.event_type, userId,companyId);
      getDailyGoalDetails();
    }
  }, [challenge?.id, challenge?.event_type, userId]);

  const getDailyGoalDetails = async()=>{
    const payload = {
      start_date:challenge.start_date,
      end_date:challenge.end_date,
      challenge_id: challenge.id,
      activity_type: challenge?.event_type === "Total Steps" ? "steps" : challenge?.event_type=="Total Calories" ? 'calories' : "distance",
      user_id:  userId
    }
    const res = await fetchApi(GetDailyGoalBreakdown,"POST",payload);
    if(res?.data?.message){
      toast.error(res?.data?.message)
    }else{
      setdailyGoalData(res.data)

    }

  }



  const showHideInviteAmigoPopup = () => {
    const updatedPopupState = !showInviteAmigoPopup;
    setShowInviteAmigoPopup(updatedPopupState);

    if (updatedPopupState) {
      dispatch(getInviteAmigosList(userId, challenge.id));
    }
  };

  const hideInviteAmigoPopup = () => {
    setShowInviteAmigoPopup(false);
  };

  const showMoreExpanded = () => {
    setShowMore((prev) => !prev);
  };


  let challengeOver = true;
  time.map((step) => {
    const values = step.split(' ');
    if (values && parseInt(values[0], 10) > 0) {
      challengeOver = false;
    }
  });
  let challengeCompetitors = {};

  let propsChallengeCompetitors = [];
  const joinOrLeave = (challenge.id !== 53) ? !challengeOver && (challenge.challenge_status === 'joined' ? 0 : 1) : (challenge.challenge_status === 'joined' ? 0 : 1);


  if (challenge.challenge_type === 'new_group') {
    const { user_details: userDetails } = userChallengeDetails;
    propsChallengeCompetitors = userDetails;
  } else {
    propsChallengeCompetitors = userChallengeDetails['user_details'];
  }

  const valid = convertDateInTimezone(challenge.end_date)._d >= moment()._d;

  if (challenge.challenge_status !== 'over' || valid) {
    challengeCompetitors = propsChallengeCompetitors;
  } else if (userChallengeDetails) {
    challengeCompetitors = propsChallengeCompetitors;
  }


  let today = moment()._d;
  let startDay = convertDateInTimezone(challenge.start_date)._d;

  const CurrentDay = moment();
  const ChallengestartDay = moment(convertDateInTimezone(challenge.start_date));

  const lastDayToJoin = challenge?.last_date_to_join
    ? moment(convertDateInTimezone(challenge?.last_date_to_join)._d)
    : null;


  let dayArr = [];
  for (let i = 0; i < challenge.days + 1; i++) {
    dayArr.push(i);
  }
  const isPastJoinDate = lastDayToJoin ? CurrentDay.isAfter(lastDayToJoin, 'day') : false;
  const buttonStatus = challenge.is_user_allowed_to_join ? true : false;

  let daysRemaining = Math.ceil(ChallengestartDay.diff(CurrentDay, 'hours') / 24);

  let daysDifference = challenge && (new Date(challenge.end_date) - new Date(challenge.start_date)) / (1000 * 60 * 60 * 24);
  const DistanceUnit = localStorage.getItem('DISTANCE');

  let Last_Day = challenge.last_date_to_join !== null ? (convertMonthFromDate(moment(convertDateInTimezone(challenge?.last_date_to_join)._d).format(' MMMM D, YYYY'), t)) : null;

  const ChallengeType = challenge.event_type;
  const activityType = ChallengeType === 'Total Distance' ? 'distance' : ChallengeType === 'Total Steps' ? 'steps' : 'calories';

  const joinChallenge = (challengeId, isJoined) => {
    setIsButtonDisabled(true);
    window.setTimeout(() => {
      setIsButtonDisabled(false);
    }, 2000);
    const data = {
      challenge_id: challengeId,
      is_joined: isJoined
    };
    dispatch(joinOrLeaveChallenge(data));
  };


  const lastJoinDate = challenge.last_date_to_join
    ? dayjs(challenge.last_date_to_join).endOf("day")
    : null;

  const isJoinExpired =
  lastJoinDate && dayjs().isAfter(lastJoinDate);

  if ((!(userChallengeDetails))) {
    return <Waiting />
  } else {
    return (
      <>
        <CommonRightCard isMargin={"0px 0px 28px 0px"}>

          {/* {(challenge.is_joined === 0 && Last_Day !== null) ? <div className="lasDay">Last day to join : {Last_Day} Day</div> : null} */}
          {(challenge.is_joined === 0 && 
            lastJoinDate &&
            !isJoinExpired 
             && challenge.challenge_status !== 'over' ) ? <Timer   data={lastJoinDate?.toDate()}  startText={"Last day to join :"} isBackgroundColor={'#FCF2F3'} width={'100%'} margin={"0px 0px 20px 0px"}/> :  (challenge.is_joined === 0 && Last_Day !== null)  ? <div className="lasDay">Last day to join : {Last_Day}</div> : null}

          {
            challenge.challenge_status == 'over' && !isEmpty(challengeCompetitors) && challengeCompetitors ?
              <CompletePointCardNew>
                <div className='width'>{"You recorded a whopping"} {challenge.event_type === 'Total Steps' ? `${commaSeperator(challengeCompetitors['steps'])} ${("Steps")}` : challenge.event_type === 'Total Calories' ? `${commaSeperator(challengeCompetitors['calories'])} calories` : `${commaSeperator(challengeCompetitors['distance'])} Miles`}&nbsp;{"in just"} {`${Math.floor(daysDifference)}`} {Math.floor(daysDifference) > 1 ? "Days" : "Day"} {"earning"}&nbsp;{challenge?.rewarded_points} Points! </div>
                {/* <div className='width'><div>{Math.floor(daysDifference) > 1 ? "Days" : "Day"} {"earning"}&nbsp;{challenge.challenge_point} Points!</div></div> */}
              </CompletePointCardNew> : 
              challenge.is_joined !== 1 && challenge.challenge_status == 'over' ?
                <CompletePointCardNew>
                  <div className='width'>Challenge Completed!
                  </div>
                </CompletePointCardNew> :

                challenge.is_joined !== 1 ?
                  <div className={isPastJoinDate ||  !buttonStatus  ? "disableButton" : "jointButton"} onClick={isButtonDisabled || isPastJoinDate ||  !buttonStatus ? null : () => joinChallenge(challenge.id, joinOrLeave)}>Join Challenge</div> : null}

          {(challenge.challenge_status == 'joined' && today < startDay) && !isEmpty(challengeCompetitors) && challengeCompetitors ?
            <CompletePointCardNew>
              <div className='width'>{`Just ${daysRemaining} days to go until your challenge begins!`}
              </div>
            </CompletePointCardNew> : null}
          {(challenge.challenge_status === 'joined' && today >= startDay) && !isEmpty(challengeCompetitors) && challengeCompetitors &&
            <ProfileContainer>
              <div style={{ display: "flex", gap: "20px" }}>
                {challengeCompetitors['profile_image'] !== "profile-Image/default.png" ?
                  <LazyImage
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "48px",
                      border: "1px solid  #DCDCDC",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    src={`${ImageUrl}/${challengeCompetitors['profile_image']}`
                    }
                  />
                  :
                  <NameInitials id="name-initials">
                    {getInitials(challengeCompetitors?.fullname)}
                  </NameInitials>
                }
                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <div className="challengeNameContainer">Hi, {challengeCompetitors?.fullname}</div>
                  <div className="challengeMessage">Here’s what you accomplished today</div>
                </div>
              </div>


              {tabValue !== 2 ? <Divider id="divider" isMargin={"20px 0px"}></Divider> : null}

              {tabValue === 2 ?
                <div className="leaderboardConatainer">
                  {(challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(challengeCompetitors) && challenge.event_type === 'Total Steps' ?
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                      {isNull(challengeCompetitors['user_rank']) ? <div className="rankText">Rank: 0</div> :
                        (today < startDay) ? <div className="rankText">-</div> :
                          <div className="rankText">Rank: {challengeCompetitors['user_rank']}{rankingDashboard(challengeCompetitors['user_rank'] - 1)}</div>}
                      <div className="challengeTypesUnit"> {challengeCompetitors['steps'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['steps'])} Steps
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>) :
                    challenge.event_type === 'Total Calories' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                        {isNull(challengeCompetitors['user_rank']) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {challengeCompetitors['user_rank']}{rankingDashboard(challengeCompetitors['user_rank'] - 1)}</div>}
                        <div className="challengeTypesUnit">  {challengeCompetitors['calories'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['calories'])} Calories
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>

                        {isNull(challengeCompetitors['user_rank']) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {challengeCompetitors['user_rank']}{rankingDashboard(challengeCompetitors['user_rank'] - 1)}</div>}

                        <div className="challengeTypesUnit"> {challengeCompetitors['distance'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? `${commaSeperator(convertMilesToKm(challengeCompetitors['distance']))} Km` : `${commaSeperator(challengeCompetitors['distance'])} Miles`}
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>)}
                </div> :

                (challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(challengeCompetitors) && challenge.event_type === 'Total Steps' ?
                  (<div className="challengeDetails profileSubContainer">
                    <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                    <div className="challengeTypesUnit"> {challengeCompetitors['steps'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['steps'])} Steps
                    </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                  </div>) :
                  challenge.event_type === 'Total Calories' ?
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                      <div className="challengeTypesUnit">  {challengeCompetitors['calories'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['calories'])} Calories
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>) :
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>
                      <div className="challengeTypesUnit"> {challengeCompetitors['distance'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? ` ${commaSeperator(convertMilesToKm(challengeCompetitors['distance']))} Km ` : ` ${commaSeperator(challengeCompetitors['distance'])} Miles`}
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>)
              }

              {challenge?.daily_goal ? <>
                <div className="goalToAcheiveConatiner">
                  <div className="goalText">Daily Goal To Achieve</div>
                  <div className="goalAcheivedText">{activityType === 'distance' ? DistanceUnit === "KILOMETER" ? commaSeperator(convertMilesToKm(challenge?.daily_goal)) : commaSeperator(challenge?.daily_goal) : commaSeperator(challenge?.daily_goal)}<span className="steps"> {activityType === 'distance' ? DistanceUnit === "KILOMETER" ? "Km" : 'Miles' : activityType === 'steps' ? 'Steps' : 'Calories'}</span></div>
                </div>


                <ProgressText>Daily Progress Tracking</ProgressText>

                {/* <ProgressCircleWrapper style={{ maxHeight: showMore ? "none" : "75px", overflow: "hidden" }}>
                  {isNull(challengeCompetitors) || isNull(challengeCompetitors['weekly_details']) ? null :
                    dayArr.map((day, index) => {
                      const dailyDetails = challengeCompetitors['daily_average'];
                      const dailyGoal = challenge?.daily_goal;

                      const isSuccess = dailyGoal && dailyDetails >= dailyGoal;

                      const backgroundColor = isSuccess ? "#75B084" : dailyGoal ? "#FCF2F3" : "#F1F8F2";
                      const borderColor = isSuccess ? "#DDEEDF" : dailyGoal ? "#F6D5D6" : "#DDEEDF";
                      const showIcon = !!isSuccess;

                      return (

                        <div className="progressWrapper" key={index}>
                          <ProgressBar
                            isShowMore={showMore}
                            backgroundColor={backgroundColor}
                            borderColor={borderColor}
                          >
                            <div className="iconContainer">
                              {showIcon && <ProgressTickIcon />}
                            </div>
                          </ProgressBar>
                          <div className="weekLabel">D{index + 1}</div>
                        </div>
                      );
                    })
                  }
                </ProgressCircleWrapper> */}
                <ProgressCircleWrapper style={{ maxHeight: showMore ? "none" : "75px", overflow: "hidden" }}>
                  {
                    dailyGoalData.map((data, index) => {
                      {/* const dailyDetails = challengeCompetitors['daily_average']; */}
                      const challengeStartDate = moment(convertDateInTimezone(challenge.start_date)._d);
                      const currentDate = moment(); // Use moment() for consistency
                      
                      const daysDifference = currentDate.diff(challengeStartDate, 'days');
                      {/* window.console.log(`Days between: ${daysDifference}`); */}
                      const dailyGoal = challenge?.daily_goal;

                      {/* const isSuccess = dailyGoal && dailyDetails >= dailyGoal; */}

                      const backgroundColor = daysDifference <= index ? "#F1F8F2" : data?.achieved ? "#75B084" : dailyGoal ? "#FCF2F3" : "#F1F8F2";
                      const borderColor = data?.achieved || daysDifference <= index ? "#DDEEDF" : dailyGoal ? "#F6D5D6" : "#DDEEDF";
                      const showIcon = !!data?.achieved;

                      return (

                        <div className="progressWrapper" key={index} title={data?.steps}>
                          <ProgressBar
                            isShowMore={showMore}
                            backgroundColor={backgroundColor}
                            borderColor={borderColor}
                          >
                            <div className="iconContainer">
                              {showIcon && <ProgressTickIcon />}
                            </div>
                          </ProgressBar>
                          <div className="weekLabel">D{index + 1}</div>
                        </div>
                      );
                    })
                  }
                </ProgressCircleWrapper>

                {challenge.days > 7 && (
                  <div className="showMoreText" onClick={() => showMoreExpanded(challenge.days)}>
                    {showMore ? "Show Less" : "Show More"}
                    <span
                      style={{
                        display: "inline-block",
                        transition: "transform 0.3s ease",
                        transform: showMore ? "rotate(180deg)" : "rotate(0deg)",
                        marginLeft: "8px"
                      }}
                    >
                      {ShowMoreArrow()}
                    </span>
                  </div>
                )}

              </> : null}
            </ProfileContainer>}


          <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{CalendarChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails"> {(lang != "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge.start_date)._d).format('ddd, Do MMM YYYY'), t)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge.start_date)._d).format('ddd, Do MMM YYYY'), t))} - {(lang != "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge.end_date)._d).format('ddd, Do MMM YYYY'), t)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge.end_date)._d).format('ddd, Do MMM YYYY'), t))}</div>
          </div>

          <Divider id="divider" isMargin={"12px 0px"}></Divider>
          <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{LocationChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails">{challenge.challenge_location}</div>
          </div>

          {challenge.challenge_point ? <><Divider id="divider" isMargin={"12px 0px"}></Divider>
            <div className="detailsContainer">
              <ManagerIconContainer isBehaviour={"default"}>{RewardsChallengeIcon()}</ManagerIconContainer>
              <div className="challengeDetails">+{challenge.challenge_point} Points</div>
            </div></>:null}

          <Divider id="divider" isMargin={"12px 0px"}></Divider>
          {challengeAttendees.length > 0 ?  <> <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{PeopleChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails" >{challengeAttendees && challengeAttendees.length} {(challengeAttendees && challengeAttendees.length) > 1 ? "Attendees" : " Attendee"}</div>
          </div>  <Divider id="divider" isMargin={"12px 0px 28px 0px"}></Divider></> : null}

          {(challenge.challenge_status === 'joined' && challenge.is_user_challenge && !isEmpty(challengeCompetitors) && challengeCompetitors) ? <div className="jointButton" onClick={() => showHideInviteAmigoPopup()}>
            <div>{InviteChallengeIcon()}</div>
            <div >Invite Friends</div>
          </div> : null}
          {challenge.challenge_status === 'over'?null: ((role==="WELLNESS_ADMIN" || role==="CONTENT_CREATOR" && challenge?.challenge_status === 'joined') || (role ==="ADMIN")) && tabValue === 2 && hasCompanyInRoute && !challenge?.is_user_challenge &&<HoverIconWrapper justify="space-between" margin="28px 0 0 0">
            <CommonButtonBorder onClick={challenge.is_team_challenge?()=>onAddUserPopup('Add', 'team'):  ()=>onAddUserPopup('Add')}>{AddUserIcon()}{challenge.is_team_challenge?"Add Team":"Add User"}</CommonButtonBorder>
            <CommonButtonBorder onClick={challenge.is_team_challenge?()=>onAddUserPopup('Remove', 'team'):()=>onAddUserPopup('Remove')}>{RemoveUserIcon()}{challenge.is_team_challenge?"Remove Team": "Remove User"}</CommonButtonBorder>
          </HoverIconWrapper>}
          <Suspense fallback={<Waiting/>}><InviteAmigoPopUp userId={userId} history={history} showModal={showInviteAmigoPopup} onHide={showHideInviteAmigoPopup} challengeId={challenge.id} plusAmigoButton={1} hideInviteAmigoPopup={hideInviteAmigoPopup}/></Suspense>
        </CommonRightCard>
      </>
    )
  }
}


ClassicRightScreen.propTypes = {
  challenge: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  history: PropTypes.object,
  tabValue: PropTypes.number,
  onAddUserPopup: PropTypes.func,
  getUserOverviewDetails: PropTypes.func.isRequired,
  role: PropTypes.string,
  hasCompanyInRoute: PropTypes.bool,
  companyId:PropTypes.number
};



export default (ClassicRightScreen);
